import * as DataTypeConstants from '../../constants/DataTypeConstants'
import DictApi from '../../api/dict/dictionary-api'
import moment from 'moment'
// TODO 注册模式
const fieldLabelTypeConfig = {
  [DataTypeConstants.FORMAT_TABLE_DICT]: {
    getFieldDataValue (rawValue, dataTypeConfig) {
      if (rawValue !== 0 && !rawValue) {
        return Promise.resolve()
      }

      return DictApi.getDictInfoByTypeCodeAndDictCode(dataTypeConfig.fieldFormatParam, rawValue).then(res => {
        return res && res.label ? res.label : '-'
      })
    }
  },
  [DataTypeConstants.FORMAT_TABLE_ROLE]: {
    getFieldDataValue (rawValue, dataTypeConfig) {
      return DictApi.getAllSysCustomerData().then(customers => {
        let label
        let customerList = customers
          .filter(customer => customer.id === rawValue)
        if (customerList.length > 0) {
          label = customerList[0].name
        } else {
          label = '-'
        }
        return label
      })
    }
  },
  [DataTypeConstants.FORMAT_TABLE_DATE]: {
    getFieldDataValue (rawValue, dataTypeConfig) {
      return Promise.resolve(moment(rawValue)
        .format(dataTypeConfig.fieldFormatParam))
    }
  },
  [DataTypeConstants.FORMAT_TABLE_INTEGER]: {
    getFieldDataValue (rawValue, dataTypeConfig) {
      return Promise.resolve(parseInt(rawValue))
    }
  },
  [DataTypeConstants.FORMAT_TABLE_DECIMAL]: {
    getFieldDataValue (rawValue, dataTypeConfig) {
      return Promise.resolve(rawValue.toFixed(dataTypeConfig.fieldFormatParam))
    }
  }
}
function getDataTypeConverter (fieldDef, item) {
  let fieldDataTypes = Object.keys(fieldLabelTypeConfig)
  if (!fieldDef.fieldDataType) {
    return false
  }
  if (!fieldDataTypes.includes(fieldDef.fieldDataType)) {
    return false
  }
  let itemName = ''
  if (fieldDef.fieldPropName) {
    itemName = fieldDef.fieldPropName
  } else {
    itemName = fieldDef.fieldPropCode + 'Name'
  }
  return convert(item[fieldDef.fieldPropCode], fieldDef).then(res => {
    item[itemName] = res
    return item
  })
  // item[itemName] = convert(item[fieldDef.fieldPropCode], fieldDef)
  // console.log('-------------------------')
  // console.log(convert(item[fieldDef.fieldPropCode], fieldDef))
}

function convert (rawValue, dataTypeConfig) {
  return fieldLabelTypeConfig[dataTypeConfig.fieldDataType]
    .getFieldDataValue(rawValue, dataTypeConfig).then(res => {
      return res
    })
}

// function convert1 (fieldDef, item) {
//   let fieldDataTypes = Object.keys(fieldDataTypeConfig)
//   if (!fieldDataType) {
//     return false
//   }
//   if (!fieldDataTypes.includes(fieldDataType)) {
//     return false
//   }
//   interface
//   return fieldDataTypeConfig[fieldDataType]
//     .getFieldDataType(fieldDef, item)
//   {
//     converter (fieldDef, item) {
//       let itemName = ''
//       if (fieldDef.fieldPropName) {
//         itemName = fieldDef.fieldPropName
//       } else {
//         itemName = fieldDef.fieldPropCode + 'Name'
//       }
//       return fieldDataTypeConfig[fieldDataType]
//         .getFieldDataType(fieldDef, item, itemName)
//     }
//   }
// }

export default {
  formatTableFieldName (items, fieldDefs) {
    if (items) {
      return Promise.all(items.map(item => {
        return Promise.all(fieldDefs.map(fieldDef => {
          const dataTypeConverter = getDataTypeConverter(fieldDef, item)
          if (!dataTypeConverter) {
            // 忽略
            return Promise.resolve()
          }
          return dataTypeConverter
        })).then((it) => {
          return item
        })
      })).then(tables => {
        return tables
      })
    }
  },
  formatResultDataFieldName (item, fieldDefs) {
    return Promise.all(fieldDefs.map(fieldDef => {
      const dataTypeConverter = getDataTypeConverter(fieldDef, item)
      if (!dataTypeConverter) {
        // 忽略
        return Promise.resolve()
      }
      return dataTypeConverter
    })).then((it) => {
      return item
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/format-table-field-util.js